import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './WebHosting.css';

const WebHosting = () => {
    return (
        <>
            <Helmet>
                <title>Web Hosting Solutions | Epicfinal</title>
                <meta name="description" content="Professional web hosting solutions including shared, VPS, and dedicated hosting services." />
            </Helmet>

            <div className="page-wrapper">
                {/* Hero Section */}
                <section className="hero-section">
                    <div className="container">
                        <div className="hero-content">
                            <h1 className="hero-title">
                                Professional Web Hosting Solutions
                            </h1>
                            <p className="hero-description">
                                Fast, secure, and reliable hosting for your website. Choose from our range of hosting plans designed to meet your needs.
                            </p>
                            <div className="hero-buttons">
                                <Link to="/pricing" className="btn btn-primary">
                                    View Pricing
                                </Link>
                                <Link to="/contact1" className="btn btn-secondary">
                                    Contact Sales
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="features-section" id="features">
                    <div className="container">
                        <div className="section-header">
                            <h2>Why Choose Our Web Hosting?</h2>
                            <p>Everything you need to get your website online</p>
                        </div>
                        <div className="features-grid">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="las la-bolt"></i>
                                </div>
                                <h3>Lightning Fast</h3>
                                <p>SSD storage and optimized servers ensure your website loads quickly</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="las la-shield-alt"></i>
                                </div>
                                <h3>Secure & Protected</h3>
                                <p>Free SSL certificates, daily backups, and advanced security measures</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="las la-clock"></i>
                                </div>
                                <h3>99.9% Uptime</h3>
                                <p>Reliable infrastructure ensures your website is always accessible</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="las la-headset"></i>
                                </div>
                                <h3>Support</h3>
                                <p>Expert support team ready to help you anytime, day or night</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Hosting Types Section */}
                <section className="hosting-types-section">
                    <div className="container">
                        <div className="section-header">
                            <h2>Choose Your Hosting Type</h2>
                            <p>Select the perfect hosting solution for your needs</p>
                        </div>
                        <div className="hosting-types-grid">
                            {/* Shared Hosting */}
                            <div className="hosting-type-card" id="shared">
                                <div className="hosting-type-header">
                                    <i className="las la-server"></i>
                                    <h3>Shared Hosting</h3>
                                </div>
                                <p className="hosting-type-description">
                                    Perfect for small websites and blogs. Affordable and easy to manage.
                                </p>
                                <ul className="hosting-features-list">
                                    <li><i className="las la-check-circle"></i> Up to 100GB SSD Storage</li>
                                    <li><i className="las la-check-circle"></i> Unlimited Bandwidth</li>
                                    <li><i className="las la-check-circle"></i> Free SSL Certificate</li>
                                    <li><i className="las la-check-circle"></i> Email Accounts</li>
                                    <li><i className="las la-check-circle"></i> cPanel Control Panel</li>
                                </ul>
                                <Link to="/pricing" className="hosting-btn">Learn More</Link>
                            </div>

                            {/* VPS Hosting */}
                            <div className="hosting-type-card featured" id="vps">
                                <div className="featured-badge">Popular</div>
                                <div className="hosting-type-header">
                                    <i className="las la-database"></i>
                                    <h3>VPS Hosting</h3>
                                </div>
                                <p className="hosting-type-description">
                                    More power and control for growing websites and applications.
                                </p>
                                <ul className="hosting-features-list">
                                    <li><i className="las la-check-circle"></i> Dedicated Resources</li>
                                    <li><i className="las la-check-circle"></i> Root Access</li>
                                    <li><i className="las la-check-circle"></i> SSD Storage</li>
                                    <li><i className="las la-check-circle"></i> Multiple OS Options</li>
                                    <li><i className="las la-check-circle"></i> Full Scalability</li>
                                </ul>
                                <Link to="/pricing" className="hosting-btn">Learn More</Link>
                            </div>

                            {/* Dedicated Hosting */}
                            <div className="hosting-type-card" id="dedicated">
                                <div className="hosting-type-header">
                                    <i className="las la-hdd"></i>
                                    <h3>Dedicated Hosting</h3>
                                </div>
                                <p className="hosting-type-description">
                                    Maximum performance with an entire server dedicated to you.
                                </p>
                                <ul className="hosting-features-list">
                                    <li><i className="las la-check-circle"></i> Full Server Control</li>
                                    <li><i className="las la-check-circle"></i> High Performance</li>
                                    <li><i className="las la-check-circle"></i> Enhanced Security</li>
                                    <li><i className="las la-check-circle"></i> Custom Configuration</li>
                                    <li><i className="las la-check-circle"></i> Managed or Unmanaged</li>
                                </ul>
                                <Link to="/pricing" className="hosting-btn">Learn More</Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cta-section">
                    <div className="container">
                        <div className="cta-content">
                            <h2>Ready to Get Started?</h2>
                            <p>Join thousands of satisfied customers hosting their websites with us</p>
                            <div className="cta-buttons">
                                <Link to="/pricing" className="btn btn-light">
                                    View All Plans
                                </Link>
                                <Link to="/contact1" className="btn btn-outline">
                                    Contact Us
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default WebHosting;
